<div class="footer-copyright">© 2017 Copyright MagicCut. All rights reserved</div>
